import Banner from '@/assets/banners/banner_InvestInterestBanner.webp';

const InvestInterestBanner = () => {
  return (
    <img src={Banner} alt="" className="" />
  );
};

export default InvestInterestBanner;